import axios from "axios";
import { fetchcontactInfoFailure, fetchcontactInfoStart, fetchcontactInfoSuccess, getInquiryFailure, getInquiryStart, getInquirySuccess, updatecontactInfoFailure, updatecontactInfoStart, updatecontactInfoSuccess } from "../slicer/contactUsSlice";

const getToken = () =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith("accessToken="))
    ?.split("=")[1];

// Helper function to get the auth headers
const getAuthHeaders = () => {
  const token = getToken();
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};
    
export const fetchContactUsData = () => async (dispatch) => {
    console.log("Fetching Contact Us Data...");
    dispatch(fetchcontactInfoStart()); // Set loading state
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/ContactUS/getContact`,
        getAuthHeaders() // Added authentication headers
      );
  
      // Check if data is an array and handle accordingly
      const data = Array.isArray(response?.data?.data)
        ? response.data.data
        : [];
  
      console.log("API Response Data:", data); // Log the full data for debugging
  
      dispatch(fetchcontactInfoSuccess(data)); // Dispatch success action
    } catch (error) {
      console.error("Error fetching Contact Us data:", error);
      dispatch(
        fetchcontactInfoFailure(
          error.response?.data?.message || "Failed to fetch Contact Us data"
        )
      );
    }
  };

  export const updateContactUsData = (contactInfo) => async (dispatch) => {
    dispatch(updatecontactInfoStart()); // Start updating
  
    try {
      // API Call to update contact information
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/ContactUS/updateContact/${contactInfo.id}`,
        contactInfo,
        getAuthHeaders() // Added authentication headers
      );
  
      console.log("Update Response:", response.data);
  
      // Dispatch success action with updated data
      dispatch(updatecontactInfoSuccess(contactInfo));
  
      // Show success alert
      alert("Contact Us updated successfully!");
    } catch (error) {
      console.error("Error updating Contact Us data:", error);
  
      // Dispatch failure action with error message
      dispatch(
        updatecontactInfoFailure(
          error.response?.data?.message || "Something went wrong while updating."
        )
      );
  
      // Show error alert
      alert(
        `Error updating Contact Us information: ${
          error.response?.data?.message || error.message || "Unknown error occurred."
        }`
      );
    }
  };

  export const fetchInquiryData = (filters = {}) => async (dispatch) => {
    console.log("Fetching Contact Us Data with filters:", filters);

    dispatch(getInquiryStart()); // Set loading state

    try {
        // Build query parameters dynamically
        const params = new URLSearchParams(filters).toString();

        // Build the API endpoint with query parameters
        const url = `${process.env.REACT_APP_BACKEND_URL}/ContactUS/getInquiry${params ? `?${params}` : ''}`;

        console.log("API Request URL:", url); // Log the full URL for debugging

        // Make the API call
        const response = await axios.get(
          url,
          getAuthHeaders() // Added authentication headers
        );

        // Safely extract the data, ensuring it’s an array
        const data = Array.isArray(response?.data?.data)
            ? response.data.data
            : [];

        console.log("API Response Data:", data); // Log the API response data

        // Dispatch success action with the fetched data
        dispatch(getInquirySuccess(data));
    } catch (error) {
        console.error("Error fetching Contact Us data:", error);

        // Dispatch failure action with an error message
        dispatch(
            getInquiryFailure(
                error.response?.data?.message || "Failed to fetch Contact Us data"
            )
        );
    }
};